import React from 'react';
import { Link } from 'react-router-dom';
import { FiTruck, FiShield, FiCreditCard, FiRefreshCw, FiArrowRight, FiMapPin, FiClock } from 'react-icons/fi';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content animate-fade-in">
            <span className="hero-badge">Premium Pet Nutrition</span>
            <h1 className="hero-title">
              Nourish Your<br />
              Beloved Companion
            </h1>
            <p className="hero-subtitle">
              Curated selection of premium pet food from trusted brands. 
              Quality nutrition delivered to your doorstep.
            </p>
            <div className="hero-buttons">
              {/* <Link to="/shop?petType=dog" className="btn btn-secondary">
                Shop for Dogs
                <FiArrowRight />
              </Link> */}
              {/* <Link to="/shop?petType=cat" className="btn btn-outline btn-light">
                Shop for Cats
                <FiArrowRight />
              </Link> */}
            </div>
          </div>
        </div>
      </section>

      {/* Delivery USP Banner */}
      <section className="usp-banner">
        <div className="container">
          <div className="usp-content">
            <div className="usp-icon">
              <FiMapPin />
            </div>
            <div className="usp-text">
              <h3>Fast & Reliable Delivery</h3>
              <p>Get your pet food delivered right to your doorstep. We ensure timely delivery for every order.</p>
            </div>
            <div className="usp-highlight">
              <FiClock />
              <span>Fast Delivery</span>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="categories-section">
        <div className="container">
          <div className="categories-grid">
            <Link to="/shop?petType=dog" className="category-card">
              <div className="category-image dog-image"></div>
              <div className="category-content">
                <h3>For Dogs</h3>
                <p>Premium nutrition for your loyal companion</p>
                <span className="category-link">
                  Explore Collection <FiArrowRight />
                </span>
              </div>
            </Link>
            <Link to="/shop?petType=cat" className="category-card">
              <div className="category-image cat-image"></div>
              <div className="category-content">
                <h3>For Cats</h3>
                <p>Delicious meals for your feline friend</p>
                <span className="category-link">
                  Explore Collection <FiArrowRight />
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <FiTruck />
              </div>
              <h3>Fast Delivery</h3>
              <p>Fast delivery to your doorstep</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <FiShield />
              </div>
              <h3>Quality Assured</h3>
              <p>100% authentic brands</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <FiCreditCard />
              </div>
              <h3>Secure Payment</h3>
              <p>Safe & encrypted checkout</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <FiRefreshCw />
              </div>
              <h3>Easy Returns</h3>
              <p>Hassle-free returns</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Shop?</h2>
            <p>Browse our complete collection of premium pet food and accessories</p>
            <Link to="/shop" className="btn btn-primary">
              Browse All Products <FiArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
